import { Component, OnInit, Input, Output , EventEmitter } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { ArticleData } from './catalogue-article.model';

@Component({
  selector: 'app-catalogue-articles',
  templateUrl: './catalogue-articles.component.html',
  styleUrls: ['./catalogue-articles.component.scss'],
  providers: [CatalogService],
})
export class CatalogueArticlesComponent implements OnInit {

  @Input() primaryTab:string;

  @Input() secondaryTab:string;

  articleList = [];

  selectedType: string;

  activeArticleData = new ArticleData();

  @Input() typeList: any;
  constructor(
    private catalogService: CatalogService,
    private toastr: ToastrService
  ) {}

  @Output() uploadThumbnailChange: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {}

  public onTypeChange(type: string) {
    this.articleList = [];
    this.selectedType = type;
    this.readArticle();
  }

  public readArticle() {
    const obj = {
      type: this.selectedType,
      year: "",
      month: ""
    };
    this.catalogService.readArticles(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.articleList = [...response.data.articles];
        } else {
        //  this.toastr.error(response.error.errorMessage);
        }
      },
      (error) => {}
    );
  }

  public onEdit(data: ArticleData) {
    this.activeArticleData = data;
  }

  public onUploadThumbnail(data: any){
    this.uploadThumbnailChange.emit(data);
  }
}
